import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Doe Vidas &copy; F5WebNet</span>
      </footer>
    );
  }
;

export default Footer;
